type Props = {
  isLive?: boolean;
};

export function ComingSoonEyebrow({ isLive = false }: Props) {
  return (
    <div className="coming-soon-eyebrow-band">
      <div className="coming-soon-eyebrow">
        <span className="rule" aria-hidden="true" />
        <span className="coming-soon-eyebrow-text">
          {isLive
            ? "Live Worship with Dorothy Ashaba"
            : "Worship with Dorothy Ashaba"}
        </span>
        <span className="rule" aria-hidden="true" />
      </div>
    </div>
  );
}
